import * as React from "react";

import { Icon } from "../../../Icons/Icon";

import { RemoveIconWrapper, Root } from "./RemoveIcon.styles";

export interface RemoveIconProps {
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
    size?: number;
    verticalAlign?: string;
}

export function RemoveIcon(props: RemoveIconProps): JSX.Element {
    return (
        <Root className={props.className} onClick={props.onClick} verticalAlign={props.verticalAlign}>
            <RemoveIconWrapper>
                <Icon name="XIcon" size={props.size ?? 24} />
            </RemoveIconWrapper>
        </Root>
    );
}
